import React from 'react';

export default function SectionTitle({ eyebrow, title, description, align = 'center', light = false }) {
  return (
    <div className={`mb-12 ${align === 'center' ? 'text-center max-w-3xl mx-auto' : 'text-left max-w-2xl'}`}>
      {eyebrow && (
        <div className={`inline-block text-xs font-bold uppercase tracking-[0.2em] mb-3 ${light ? 'text-japo-yellow' : 'text-japo-green'}`}>
          {eyebrow}
        </div>
      )}
      <h2 className={`text-3xl md:text-4xl lg:text-5xl font-extrabold mb-4 tracking-tight ${light ? 'text-white' : 'text-gray-900'}`}>
        {title}
      </h2>
      {description && (
        <p className={`text-base md:text-lg leading-relaxed ${light ? 'text-white/80' : 'text-gray-600'}`}>{description}</p>
      )}
    </div>
  );
}
